import { render, staticRenderFns } from "./SupportCase.vue?vue&type=template&id=4e9bccf7"
import script from "./SupportCase.vue?vue&type=script&lang=js"
export * from "./SupportCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports